import { useState, useEffect } from 'react';
import getJobsList from '../../utils/get-jobs-list';

export const useJobsList = (data) => {
  const [valuesCatJobs, setValuesCatJobs] = useState([]);
  const [jobsSelected, setJobsSelected] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const res = await getJobsList(data);
      setValuesCatJobs(res.values);
      setJobsSelected(res.jobsSelected);
    };

    fetchData();
  }, [data]);

  return { valuesCatJobs, jobsSelected };
};
